import { Image } from '@radix-ui/react-avatar'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
  memo,
} from 'react'
import { useStableAttachmentUrl } from '#src/hooks/useStableAttachmentUrl.ts'

export const AvatarImage = memo(
  forwardRef<ElementRef<typeof Image>, ComponentPropsWithoutRef<typeof Image>>(
    ({ className, src, ...props }, ref) => {
      const cachedSrc = useStableAttachmentUrl(
        typeof src === 'string' ? src : undefined
      )

      return (
        <Image
          ref={ref}
          className={cn('aspect-square size-full', className)}
          src={cachedSrc}
          {...props}
        />
      )
    }
  )
)
AvatarImage.displayName = Image.displayName
